import React, { Fragment } from "react";
import { Line } from "react-chartjs-2";

import { patternsByIds } from "../../constants/patterns";
import { patternCollectionsByIds } from "../../constants/patternCollections";
import {
  xValues,
  tableYValuesIndex
} from "../../constants/patternAcousticPerformances";
import getPatternAcousticPerfChartData from "../../utils/getPatternAcousticPerfChartData";
import chartOptions from "../../constants/acousticPerfChartOptions";

const AcousticPerfModal = props => {
  const pattern = patternsByIds[props.patternId];
  const collection = patternCollectionsByIds[pattern.collectionId];
  const chartData = getPatternAcousticPerfChartData(props.data);

  return (
    <Fragment>
      <div className="modal__header">
        <span>{props.t("modals:acousticPerformanceTitle")}</span>
      </div>

      <div className="modal__body">
        <div className="modal__close" onClick={props.handleCloseModal}>
          <svg className="bars-icon" viewBox="0 0 24 24">
            <path d="M1,1 L22,22 M1,22 L22,1" stroke="#000" strokeWidth="1" />
          </svg>
        </div>

        <div className="acoustic-perf-modal">
          {props.data && (
            <div className="acoustic-perf-modal__body">
              <div className="acoustic-perf-modal__graph">
                <Line data={chartData} options={chartOptions} />
              </div>
              <div className="acoustic-perf-modal__table">
                <table>
                  <tbody>
                    <tr>
                      <td>f(Hz)</td>
                      <td>&alpha;&rho;</td>
                    </tr>
                    {tableYValuesIndex.map(index => (
                      <tr key={`ap-${index}`}>
                        <td>{xValues[index]}</td>
                        <td>{props.data[index]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {(!props.data)&& (
            <div className="mt4 h5 tc">
              {props.t("editor:acousticPerformanceComingSoon")}
            </div>
          )}
          <div className="acoustic-perf-modal__footer">
            <div className="acoustic-perf-modal__left">
              <div className="acoustic-perf-modal__collection-title">
                {collection["title_"+props.lng]}
              </div>
              <div className="acoustic-perf-modal__pattern-title">
                {pattern["title_"+props.lng]}
              </div>
            </div>

            <div className="acoustic-perf-modal__right">
              <div className="">
                {props.t("editor:PerforationRateLabel")} {props.perforationRatio}
              </div>
              <div className="">&alpha;w : {props.alphaSabine}</div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AcousticPerfModal;



// WEBPACK FOOTER //
// ./src/components/modals/AcousticPerfModal.js